import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { BarChart2, Plus } from 'lucide-react';
import { API } from '../App';

export function PollPanel({ frayId }) {
  const [polls, setPolls] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [question, setQuestion] = useState('');
  const [options, setOptions] = useState(['', '']);

  useEffect(() => {
    API.get(`/api/frays/${frayId}/polls`).then(r => setPolls(r.data.polls || [])).catch(() => {});
  }, [frayId]);

  const createPoll = async () => {
    if (!question.trim() || options.filter(o => o.trim()).length < 2) return;
    try {
      await API.post(`/api/frays/${frayId}/polls`, { question, options: options.filter(o => o.trim()) });
      setQuestion(''); setOptions(['', '']); setShowCreate(false);
      const r = await API.get(`/api/frays/${frayId}/polls`);
      setPolls(r.data.polls || []);
    } catch {}
  };

  const vote = async (pollId, option) => {
    try {
      const r = await API.post(`/api/frays/${frayId}/polls/${pollId}/vote`, { option });
      setPolls(prev => prev.map(p => p.id === pollId ? { ...p, tally: r.data.tally, total_votes: r.data.total_votes } : p));
    } catch {}
  };

  return (
    <div className="space-y-3" data-testid="poll-panel">
      <div className="flex items-center justify-between">
        <h3 className="text-xs font-mono text-[#A0A0A0]">POLLS</h3>
        <button onClick={() => setShowCreate(!showCreate)} className="text-[#A0A0A0] hover:text-[#FF4D00]">
          <Plus className="w-3.5 h-3.5" />
        </button>
      </div>

      {showCreate && (
        <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} className="p-3 bg-[#1A1A1A] border border-[#2A2A2A]">
          <input type="text" value={question} onChange={e => setQuestion(e.target.value)}
            className="w-full px-2 py-1 bg-[#0F0F0F] border border-[#2A2A2A] text-xs mb-2 focus:outline-none focus:border-[#FF4D00]"
            placeholder="Question..." />
          {options.map((opt, i) => (
            <input key={i} type="text" value={opt} onChange={e => { const n = [...options]; n[i] = e.target.value; setOptions(n); }}
              className="w-full px-2 py-1 bg-[#0F0F0F] border border-[#2A2A2A] text-xs mb-1 focus:outline-none focus:border-[#FF4D00]"
              placeholder={`Option ${i + 1}`} />
          ))}
          <div className="flex gap-1 mt-2">
            <button onClick={() => setOptions([...options, ''])} className="text-[9px] text-[#A0A0A0] border border-[#2A2A2A] px-2 py-0.5">+ Option</button>
            <button onClick={createPoll} className="text-[9px] bg-[#FF4D00] text-black px-2 py-0.5 ml-auto">Create</button>
          </div>
        </motion.div>
      )}

      {polls.map(poll => (
        <div key={poll.id} className="p-3 bg-[#1A1A1A] border border-[#2A2A2A]">
          <p className="text-xs font-medium mb-2">{poll.question}</p>
          <div className="space-y-1">
            {poll.options?.map((opt, i) => {
              const votes = poll.tally?.[opt] || 0;
              const total = poll.total_votes || 1;
              const pct = Math.round((votes / total) * 100);
              return (
                <button key={i} onClick={() => vote(poll.id, opt)} className="w-full text-left relative overflow-hidden">
                  <div className="absolute inset-0 bg-[#FF4D00]/10" style={{ width: `${pct}%` }} />
                  <div className="relative flex items-center justify-between px-2 py-1 text-[10px]">
                    <span>{opt}</span>
                    <span className="font-mono text-[#A0A0A0]">{votes} ({pct}%)</span>
                  </div>
                </button>
              );
            })}
          </div>
          <span className="text-[8px] text-[#A0A0A0] font-mono mt-1 block">{poll.total_votes || 0} votes</span>
        </div>
      ))}
    </div>
  );
}
